/**
 * Pure empty-state copy for the /tasks page.
 *
 * Lives outside `tasks.tsx` so unit tests can import the strings
 * without the React/TanStack Query dep tree the page module pulls in.
 * The page re-exports both functions so existing call sites that use
 * `import { emptyStateTitle } from '@/pages/tasks'` keep working.
 */

import type { TaskFilter } from '../api/tasks'

/**
 * Title shown in the empty state. Mirrors the Tasker convention: a
 * single noun-phrase, no trailing period.
 */
export function emptyStateTitle(filter: TaskFilter): string {
  if (filter === 'all') {
    return 'All caught up'
  }
  if (filter === 'overdue') {
    return 'No overdue tasks'
  }
  return 'Nothing in this view'
}

/**
 * One-line description shown below the empty-state title. State-of-
 * the-world sentence ending in a period.
 */
export function emptyStateDescription(filter: TaskFilter): string {
  if (filter === 'all') {
    return "Nothing's blocking your work right now."
  }
  if (filter === 'overdue') {
    return 'Anything past due will surface here.'
  }
  return 'Try clearing the filter — you may have tasks in other categories.'
}
